import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../styles/bootstrap.min.css';
import '../styles/style.css';
import MainSidebar from '../components/MainSidebar';
import rightarrow from '../assets/images/right.svg';
import verified from '../assets/images/verified.svg';
import loaderIcon from '../assets/images/loader.gif';
import config from '../config/config';

const ChatSend = () => {
  const [userData, setUserData] = useState({ email: '', user_name: '' });
  const [followedUsers, setFollowedUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [filter, setFilter] = useState('recent');
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/Login');
      return;
    }

    const fetchUserDetails = async () => {
      try {
        const response = await axios.get(`${config.baseURL}/current-user-details`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const user = response.data.data.user;
        setUserData(user);
      } catch (error) {
        console.error('Error fetching user details', error);
      }
    };

    const fetchFollowedUsers = async () => {
      try {
        const response = await axios.get(`${config.baseURL}/get-following-users`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setFollowedUsers(response.data.followed_users || []);
        setFilteredUsers(response.data.followed_users || []);
      } catch (error) {
        console.error('Error fetching followed users', error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserDetails();
    fetchFollowedUsers();
  }, [navigate]);

  useEffect(() => {
    let filtered = followedUsers;

    // Search filter
    if (searchTerm) {
      filtered = filtered.filter(user =>
        user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        user.username.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    // Sort filter
    switch (filter) {
      case 'name':
        filtered.sort((a, b) => a.name.localeCompare(b.name));
        break;
      case 'available':
        // Add sorting logic for availability if needed
        break;
      case 'ascending':
        filtered.sort((a, b) => a.name.localeCompare(b.name));
        break;
      case 'descending':
        filtered.sort((a, b) => b.name.localeCompare(a.name));
        break;
      default:
        // Default sorting if needed
        break;
    }

    setFilteredUsers(filtered);
  }, [searchTerm, filter, followedUsers]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleFilterChange = (e) => {
    setFilter(e.target.value);
  };

  const handleBackClick = () => {
    navigate(-1); // Go back to the previous page
  };

  const getInitials = (name) => {
    const nameParts = name.split(' ');
    if (nameParts.length === 1) return nameParts[0][0].toUpperCase();
    return (nameParts[0][0] + nameParts[1][0]).toUpperCase();
  };



  return (
    <div>
      <div className="main_patreonpass_wrapper">
        <div className="patreonpass_container">
          <div className="left_sidebar">
            <MainSidebar />
          </div>
          <div className="patreonpass_main_content edit_profile_settings" id="content">
            <div className="chat_main_content">
              <div className="feed_wrapper">
                <div className="page_title_with_dropdown notification_page">
                  <div className="page_heading">
                    <button className="profile_back_btn" onClick={handleBackClick}>
                      <svg width={54} height={54} viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M48 27.5363L5.99998 27.5363M5.99998 27.5363L27 49.0532M5.99998 27.5363L27 6.3032" stroke="#222" strokeWidth={6} strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </button>
                    <h1>New Message</h1>
                  </div>                  
                </div>

                <div className="chat_user_list">

                  <div className="search_box_wrapper">
                    <div className="chat_search_icon">
                        <svg
                          className="heading_search_icon"
                          width={38}
                          height={38}
                          viewBox="0 0 38 38"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M30.9109 17.3353C30.9109 24.7219 24.8843 30.7294 17.426 30.7294C9.96774 30.7294 3.94118 24.7219 3.94118 17.3353C3.94118 9.94871 9.96774 3.94118 17.426 3.94118C24.8843 3.94118 30.9109 9.94871 30.9109 17.3353Z"
                            stroke="#ccc"
                            strokeWidth="3.88235"
                          />
                          <path
                            d="M33.6317 36.3769C34.392 37.1327 35.6211 37.1291 36.3769 36.3688C37.1327 35.6085 37.1291 34.3794 36.3688 33.6236L33.6317 36.3769ZM36.3688 33.6236L29.144 26.4412L26.4068 29.1945L33.6317 36.3769L36.3688 33.6236Z"
                            fill="#ccc"
                          />
                        </svg>
                    </div>
                    <input
                      type="text"
                      placeholder="Search"
                      value={searchTerm}
                      onChange={handleSearchChange}
                    />
                  </div>
                  

                </div>
                
                <div className="chat_message_block">
                    <div className="post_top_section_head">
                      <div className="title_post_head">RECENT</div>
                      <div className="title_post_head_shorting">
                        {/* <div className="shorting_icons my_profile_menu">
                          <a
                            href="#"
                            className="shorting_lists"
                            id="productsDropdown"
                            role="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <svg
                              width={54}
                              height={54}
                              viewBox="0 0 54 54"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M4 44H15.3333"
                                stroke="#8A96A3"
                                strokeWidth="7.08333"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M4 27H32.3333"
                                stroke="#8A96A3"
                                strokeWidth="7.08333"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M4 10H49.3333"
                                stroke="#8A96A3"
                                strokeWidth="7.08333"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </a>
                           <ul className="dropdown-menu" aria-labelledby="productsDropdown">
                          <li className="dropdown">
                            <input
                              type="radio"
                              id="recent"
                              name="filter"
                              value="recent"
                              checked={filter === 'recent'}
                              onChange={handleFilterChange}
                            />
                            <label htmlFor="recent" className="dropdown-item">
                              Recent
                            </label>
                          </li>
                          <li className="dropdown">
                            <input
                              type="radio"
                              id="name"
                              name="filter"
                              value="name"
                              checked={filter === 'name'}
                              onChange={handleFilterChange}
                            />
                            <label htmlFor="name" className="dropdown-item">
                              Name
                            </label>
                          </li>
                          <li className="dropdown">
                            <input
                              type="radio"
                              id="ascending"
                              name="filter"
                              value="ascending"
                              checked={filter === 'ascending'}
                              onChange={handleFilterChange}
                            />
                            <label htmlFor="ascending" className="dropdown-item">
                              Ascending
                            </label>
                          </li>
                          <li className="dropdown">
                            <input
                              type="radio"
                              id="descending"
                              name="filter"
                              value="descending"
                              checked={filter === 'descending'}
                              onChange={handleFilterChange}
                            />
                            <label htmlFor="descending" className="dropdown-item">
                              Descending
                            </label>
                          </li>
                        </ul>
                        </div> */}
                      </div>
                    </div>

                    <div className="chat_user_list">                      

                      {loading ? (
                          <div className="loader_box text-center">
                            <img src={loaderIcon} className="loading_icon" alt="Loading..." />
                          </div>
                        ) : filteredUsers.length > 0 ? (
                          <div className="users_list">
                            {filteredUsers.map((user, index) => (
                        <Link key={index} to={`/chatmessage/${user.user_id}`} className="chate_user_block">
                            <div className="client-img">
                              <div className="lazy-container user_image">
                                <div className={user.user_online_status === 'online' ? 'user_online_status online' : ''}>
                                  {user.profile ? (
                                    <img src={user.profile} alt={`${user.name} Image`} />
                                  ) : (
                                    <div className="user_initials">
                                     {getInitials(user.name)} 
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="chat_message_inside_list">
                              <div className="chat_message_top_right">
                                <div className="chat_message_top_right_left chat_name_limit_remove">
                                  <span>{user.name}  <img src={verified} alt="" /></span>{" "}
                                  
                                </div>                              
                              </div>
                              
                              <div className="chat_username">
                                @{user.username}
                              </div>  

                            </div>
                          </Link>

                            ))}
                          </div>
                        ) : (
                          <div className="no_results">No results found</div>
                        )}



                    </div>      
                          
                  </div>
              </div>
            </div>
            <div className="right_main_content chat_messages">                
                <div className="page_title_with_dropdown notification_page">
                  <div className="page_heading">
                    <h1>SELECT USERS TO SEND THEM A MESSAGE</h1>
                  </div>
                </div> 

                <div className="when_chat_blank">

                    <div className="alert mb-0 alert-info mt-50">
                      <svg
                        className="m-alert-icon g-icon"
                        width={54}
                        height={54}
                        viewBox="0 0 54 54"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M27 49C39.1503 49 49 39.1503 49 27C49 14.8497 39.1503 5 27 5C14.8497 5 5 14.8497 5 27C5 39.1503 14.8497 49 27 49Z"
                          stroke="#00aff0"
                          strokeWidth="4.71429"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M25.0684 27.4207L27.7631 26.3428V37.3016V38.5591H31.7155"
                          stroke="#00aff0"
                          strokeWidth="3.14286"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <circle cx="27.4193" cy="17.9901" r="3.5619" fill="#00aff0" />
                      </svg>
                      <div className="alert-text-wrapper">
                        Please select recepient
                      </div>
                    </div>

                </div>     

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatSend;